import {
  Element as SlateElement,
  Text
} from 'slate';

import types from '../../elements/types';

const listItemTypes = [
  types.NUMBERED_LIST_ITEM,
  types.BULLETED_LIST_ITEM
];

const listTypes = [
  types.NUMBERED_LIST,
  types.BULLETED_LIST
];

function hasProtectedNesting(editor, node) {

  const firstChild = node.children[0];
  const lastChild = node.children[node.children.length - 1];

  const leadsWithLine = Text.isText(firstChild) || (SlateElement.isElement(firstChild) && editor.isInline(firstChild));
  const trailsWithList = SlateElement.isElement(lastChild) && listTypes.includes(lastChild.type);

  return leadsWithLine === true && trailsWithList === true;

}

function withNestedListItem(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = function nestedListItemNormalize(entry) {

    const node = entry[0];

    if (SlateElement.isElement(node) && listItemTypes.includes(node.type)) {
      if (hasProtectedNesting(editor, node) === true) {
        return;
      }
    }

    normalizeNode(entry);

  };

  return editor;

}

export default withNestedListItem;
